// extracted by mini-css-extract-plugin
export default {"miniappIframe":"index-module--miniappIframe--pcUet"};